import apiInstance from "../axios";
import { AxiosResponse } from "axios";
import { checkResponseStatus } from "./checkResponseStatus";

interface GetRequestOptions {
  route: string;
  queryParams?: any;
  pathVariables?: Record<string, string>;
}

export async function getRequest(
  options: GetRequestOptions
): Promise<AxiosResponse> {
  const { route, queryParams, pathVariables } = options;

  try {
    let modifiedRoute = route;

    const config = {
      params: queryParams,
    };

    if (pathVariables) {
      Object.entries(pathVariables).forEach(([key, value]) => {
        modifiedRoute = modifiedRoute.replace(`:${key}`, value);
      });
    }

    const response = await apiInstance.get(modifiedRoute, config);
    checkResponseStatus(response.status);
    return response;
  } catch (error: any) {
    if (error.response) {
      checkResponseStatus(error.response.status);
      return error.response;
    }
    return error;
  }
}
